import { render, staticRenderFns } from "./PartnersRegister.vue?vue&type=template&id=16c9a18e&scoped=true"
import script from "./PartnersRegister.vue?vue&type=script&lang=js"
export * from "./PartnersRegister.vue?vue&type=script&lang=js"
import style0 from "./PartnersRegister.vue?vue&type=style&index=0&id=16c9a18e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c9a18e",
  null
  
)

export default component.exports